import React, { useState, useEffect, createContext } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useParams } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import LandingPage1 from './Landingpage/LandingPage1';
import SignIn from './Admin/SignIn';
import ProtectedRoute from './Admin/ProtectedRoute';
import FreelanceOnboarding from './FreelanceQuestions/FreelanceOnboarding';
import TeamDashboard from './Admin/Teamdashboard';
import PrivacyPolicy from './Landingpage/PrivacyPolicy';
import TermsAndConditions from './Landingpage/TermsAndConditions';
import AGB from './Landingpage/AGB';
import Imprint from './Landingpage/Imprint';
import DPA from './Landingpage/DPA';
import ScrollToTop from './Landingpage/ScrollToTop';
import LandingPageBnb1 from './Landingpage/LandingPageBnb1';
import LandingPageBnb2 from './Landingpage/LandingPageBnb2';
import LandingPageBnb3 from './Landingpage/LandingPageBnb3';
import LandingPageBnb4 from './Landingpage/LandingPageBnb4';
import LandingPageBnb5 from './Landingpage/LandingPageBnb1CTA';
import LandingPageBnb1CTA from './Landingpage/LandingPageBnb1CTA';
import LandingPageBnb2CTA from './Landingpage/LandingPageBnb2CTA';
import LandingPageBnb3CTA from './Landingpage/LandingPageBnb3CTA';
import LandingPageBnb4CTA from './Landingpage/LandingPageBnb4CTA';
import BookingPage1 from './Landingpage/BookingPage1';
import PasswordProtection from './Landingpage/PasswordProtection';
import PricingPage from './Landingpage/PricingPage';
import LeadCapture from './Landingpage/LeadCapture';
import PartnerCapture from './Landingpage/PartnerCapture';
import AuditFunnel from './Landingpage/AuditFunnel';
import ResearchPage from './Research/ResearchPage';
import ResearchAdmin from './Research/ResearchAdmin';
import AcademyApp from './Academy/AcademyApp';
import ProtocoolForm from './Protocool/ProtocoolForm';
import AccountSetupForm from './Protocool/AccountSetupForm';
import MemberPayouts from './Payouts/MemberPayouts';
import TeamProvi from './Admin/TeamProvi';

const LegacyTeamProvi = () => {
  const { spec } = useParams();
  const { pathname, search } = useLocation();
  const de = pathname.startsWith('/de') ? '/de' : '';
  const next = spec ? `${de}/teampayout-${spec}${search}` : `${de}/teampayout${search}`;
  return <Navigate to={next} replace />;
};

// Firebase Auth Kontext erstellen
export const AuthContext = createContext({
  isAuthenticated: false,
  shouldUseFirebase: false
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(true); // Standardmäßig auf true gesetzt
  const [shouldUseFirebase, setShouldUseFirebase] = useState(true); // Standardmäßig auf true gesetzt
  
  // Beim Laden der App prüfen, ob der Benutzer bereits authentifiziert ist
  useEffect(() => {
    // Passwortschutz temporär deaktiviert
    // const authStatus = localStorage.getItem('isAuthenticated');
    // if (authStatus === 'true') {
    //   setIsAuthenticated(true);
    //   // Firebase-Zugriff erst nach kurzer Verzögerung aktivieren
    //   setTimeout(() => {
    //     setShouldUseFirebase(true);
    //   }, 1000);
    // }
  }, []);
  
  // Erfolgreiches Login behandeln
  const handleAuthentication = () => {
    setIsAuthenticated(true);
    // Firebase-Zugriff erst nach erfolgreicher Authentifizierung aktivieren
    setTimeout(() => {
      setShouldUseFirebase(true);
    }, 1000);
  };

  // Passwortschutz temporär deaktiviert
  // Wenn nicht authentifiziert, Passwortschutz anzeigen
  // if (!isAuthenticated) {
  //   return <PasswordProtection onAuthenticated={handleAuthentication} />;
  // }

  // Ansonsten die normale App rendern
  return (
    <AuthContext.Provider value={{ isAuthenticated, shouldUseFirebase }}>
      <Router>
        <LanguageProvider>
          <div className="App">
            <ScrollToTop /> {/* Füge ScrollToTop hier ein */}
            <Routes>
              {/* English Routes */}
              <Route path="/" element={<LandingPage1 />} />
              <Route path="/_1airbnb" element={<LandingPageBnb1 />} />
              <Route path="/_2airbnb" element={<LandingPageBnb2 />} />
              <Route path="/_3airbnb" element={<LandingPageBnb3 />} />
              <Route path="/_4airbnb" element={<LandingPageBnb4 />} />
              <Route path="/_1airbnbs" element={<LandingPageBnb1CTA />} />
              <Route path="/_2airbnbs" element={<LandingPageBnb2CTA />} />
              <Route path="/_3airbnbs" element={<LandingPageBnb3CTA />} />
              <Route path="/_4airbnbs" element={<LandingPageBnb4CTA />} />
              <Route path="/book-call-1" element={<BookingPage1 />} />
              <Route path="/apply" element={<FreelanceOnboarding />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/legal" element={<Imprint />} />
              <Route path="/imprint" element={<Navigate to="/legal" replace />} />
              <Route path="/impressum" element={<Navigate to="/legal" replace />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/agbs" element={<AGB />} />
              <Route path="/dpa" element={<DPA />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/get-started" element={<LeadCapture />} />
              <Route path="/partners" element={<PartnerCapture />} />
              <Route path="/audit" element={<AuditFunnel />} />
              {/* Hidden / unlisted research report route (noindex) */}
              <Route path="/research" element={<ResearchPage />} />
              <Route path="/research/:slug" element={<ResearchPage />} />
              <Route path="/research-admin" element={<ProtectedRoute element={<ResearchAdmin />} />} />
              {/* Hidden / unlisted protocool share pages (noindex, password-gated) */}
              <Route path="/protocool/:slug/:linkKey" element={<ProtocoolForm />} />
              {/* Account-Setup-Protokoll: teilbare, secret-key-geschützte Setup-Seite */}
              <Route path="/setup/:slug" element={<AccountSetupForm />} />
              {/* Auszahlungen: teilbare, secret-key-geschützte Seite je Teammitglied */}
              <Route path="/payouts/:memberId" element={<MemberPayouts />} />
              {/* Academy — public dummy for now (later gated like research pages) */}
              <Route path="/academy/*" element={<AcademyApp />} />
              <Route path="/guest-pages" element={<div>Guest Pages</div>} />
              <Route path="/auto-agency" element={<div>Auto Agency</div>} />
              <Route path="/bonus-links" element={<div>Bonus Links</div>} />
              <Route path="/teamdashboard" element={<ProtectedRoute element={<TeamDashboard />} />} />
              {/* Hidden / unlisted team commission calculator (noindex) */}
              <Route path="/teampayout-:spec" element={<TeamProvi />} />
              <Route path="/teampayout" element={<TeamProvi />} />
              <Route path="/teamprovi-:spec" element={<LegacyTeamProvi />} />
              <Route path="/teamprovi" element={<LegacyTeamProvi />} />
              
              {/* German Routes - same components, language from /de path */}
              <Route path="/de" element={<LandingPage1 />} />
              <Route path="/de/_1airbnb" element={<LandingPageBnb1 />} />
              <Route path="/de/_2airbnb" element={<LandingPageBnb2 />} />
              <Route path="/de/_3airbnb" element={<LandingPageBnb3 />} />
              <Route path="/de/_4airbnb" element={<LandingPageBnb4 />} />
              <Route path="/de/_1airbnbs" element={<LandingPageBnb1CTA />} />
              <Route path="/de/_2airbnbs" element={<LandingPageBnb2CTA />} />
              <Route path="/de/_3airbnbs" element={<LandingPageBnb3CTA />} />
              <Route path="/de/_4airbnbs" element={<LandingPageBnb4CTA />} />
              <Route path="/de/book-call-1" element={<BookingPage1 />} />
              <Route path="/de/apply" element={<FreelanceOnboarding />} />
              <Route path="/de/signin" element={<SignIn />} />
              <Route path="/de/privacy" element={<PrivacyPolicy />} />
              <Route path="/de/legal" element={<Imprint />} />
              <Route path="/de/imprint" element={<Navigate to="/de/legal" replace />} />
              <Route path="/de/impressum" element={<Navigate to="/de/legal" replace />} />
              <Route path="/de/terms" element={<TermsAndConditions />} />
              <Route path="/de/agbs" element={<AGB />} />
              <Route path="/de/dpa" element={<DPA />} />
              <Route path="/de/pricing" element={<PricingPage />} />
              <Route path="/de/get-started" element={<LeadCapture />} />
              <Route path="/de/partners" element={<PartnerCapture />} />
              <Route path="/de/audit" element={<AuditFunnel />} />
              <Route path="/de/guest-pages" element={<div>Guest Pages</div>} />
              <Route path="/de/auto-agency" element={<div>Auto Agency</div>} />
              <Route path="/de/bonus-links" element={<div>Bonus Links</div>} />
              <Route path="/de/teamdashboard" element={<ProtectedRoute element={<TeamDashboard />} />} />
              <Route path="/de/teampayout-:spec" element={<TeamProvi />} />
              <Route path="/de/teampayout" element={<TeamProvi />} />
              <Route path="/de/teamprovi-:spec" element={<LegacyTeamProvi />} />
              <Route path="/de/teamprovi" element={<LegacyTeamProvi />} />
              <Route path="/de/research" element={<ResearchPage />} />
              <Route path="/de/research/:slug" element={<ResearchPage />} />
              <Route path="/de/research-admin" element={<ProtectedRoute element={<ResearchAdmin />} />} />
              <Route path="/de/protocool/:slug/:linkKey" element={<ProtocoolForm />} />
              <Route path="/de/setup/:slug" element={<AccountSetupForm />} />
              <Route path="/de/payouts/:memberId" element={<MemberPayouts />} />
              <Route path="/de/academy/*" element={<AcademyApp />} />
            </Routes>
          </div>
        </LanguageProvider>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
